import React from 'react';
import styles from './index.module.scss';
import EcoImg from 'eco-design/base/eco-img';
import { DrapDown } from '../icons';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

const Scenarios: React.FC = () => {
    const { t } = useLang('Delta3MaxSeriesPreheat.scenarios');
    const scenariosData = [
        {
            imgPc: 'https://websiteoss.ecoflow.com/upload/image/1756257894842/scenarios-item1-pc.jpg',
            imgH5: 'https://websiteoss.ecoflow.com/upload/image/1756257894275/scenarios-item1-m.jpg',
            title: t('item_title1'),
            use: t('item_use1'),
            desc: t('item_desc1'),
            targetEle: 'EcoFlow_DELTA_3_Max_Plus',
            key: '1',
        },
        {
            imgPc: 'https://websiteoss.ecoflow.com/upload/image/1756257895058/scenarios-item2-pc.jpg',
            imgH5: 'https://websiteoss.ecoflow.com/upload/image/1756257894630/scenarios-item2-m.jpg',
            title: t('item_title2'),
            use: t('item_use2'),
            desc: t('item_desc2'),
            targetEle: 'EcoFlow_DELTA_3_Max',
            key: '2',
        },
        {
            imgPc: 'https://websiteoss.ecoflow.com/upload/image/1756257895248/scenarios-item3-pc.jpg',
            imgH5: 'https://websiteoss.ecoflow.com/upload/image/1756257894426/scenarios-item3-m.jpg',
            title: t('item_title3'),
            use: t('item_use3'),
            desc: t('item_desc3'),
            targetEle: 'd3mProductList',
            key: '3',
        },
    ];

    const handleScrollto = (elSelector: string, i: number) => {
        const el = document.querySelector(`#${elSelector}`);
        gtm.push({
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: scenariosData[i].targetEle,
            button_name: scenariosData[i].title,
        });
        if (el) {
            const offset = 120; // 偏移量
            const targetPosition = el.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });
        }
    };

    return (
        <section className={styles.Scenarios}>
            <h4 className="scenarios-title">{t('title')}</h4>
            <div className="scenarios-content">
                {scenariosData.map((item, i) => (
                    <div className="scenarios-item" key={item.key} onClick={() => handleScrollto(item.targetEle, i)}>
                        <EcoImg pc={item.imgPc} alt={item.desc} pad={item.imgPc} h5={item.imgH5}></EcoImg>
                        <div className="scenarios-item-wrap">
                            <div className="scenarios-item-content">
                                <div className="item-title">{item.title}</div>
                                <div className="item-use">{item.use}</div>
                                <div className="item-desc">{item.desc}</div>
                            </div>
                            <span className="item-icon">
                                <DrapDown></DrapDown>
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default Scenarios;
